<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      // Default `null` instead of `{}` so the `v-if="action?.type"` guard in
      // the template only renders the action container when the caller actually
      // passed an action. An empty `{}` would be truthy under a plain `v-if="action"`
      // check and reserve visual space in the toast for nothing.
      default: null,
    },
  },
  methods: {
    onActionClick() {
      if (this.action && typeof this.action.onClick === 'function') {
        this.action.onClick();
      }
    },
  },
};
</script>

<template>
  <div>
    <div
      class="shadow-sm bg-slate-800 dark:bg-slate-700 rounded-[4px] items-center gap-3 inline-flex mb-2 max-w-[25rem] min-h-[1.875rem] min-w-[15rem] px-6 py-3 text-left"
      role="status"
      aria-live="polite"
    >
      <div class="text-sm font-medium text-white dark:text-white">
        {{ message }}
      </div>
      <div v-if="action?.type">
        <router-link
          v-if="action.type === 'link'"
          :to="action.to"
          class="font-medium cursor-pointer select-none text-woot-500 dark:text-woot-500 hover:text-woot-600 dark:hover:text-woot-600"
        >
          {{ action.message }}
        </router-link>
        <button
          v-else-if="action.type === 'button'"
          type="button"
          class="font-medium cursor-pointer select-none text-woot-500 dark:text-woot-500 hover:text-woot-600 dark:hover:text-woot-600 bg-transparent border-0 p-0"
          @click="onActionClick"
        >
          {{ action.message }}
        </button>
      </div>
    </div>
  </div>
</template>
